import { apiClient } from './api';

export interface GeneratePromptRequest {
  campaignId?: string;
  conversationStyle: string;
  personalityType: string;
  persuasionApproach: string;
}

export interface GeneratePromptResponse {
  prompt: string;
}

export const conversationStyleService = {
  // Generate prompt for conversation style
  async generatePrompt(data: GeneratePromptRequest): Promise<GeneratePromptResponse> {
    const response = await apiClient.post<{ enhancedPromptScript: string }>(
      '/conversation-styles/generate-prompt',
      data
    );
    return {
      prompt: response.data.data.enhancedPromptScript
    };
  },
};